import React from "react";
import { NavLink } from "react-router-dom";
import cls from "./Sidebar.module.scss";
import { useAuth } from "../auth/AuthContext";
import { ASSISTANT_REVIEW_ROLES, isAssistantReviewPortal } from "../assistant/reviewAccess";

const Sidebar: React.FC = () => {
    const { user } = useAuth();
    const canReview = ASSISTANT_REVIEW_ROLES.some(role => user?.roles?.includes(role));
    if (isAssistantReviewPortal()) return <aside className={cls.sidebar}>
        <div className={cls.brand}>Обучение ИИ</div>
        {canReview && <><NavLink to="/assistant-history" className={({ isActive }) => isActive ? `${cls.link} ${cls.active}` : cls.link}>История ответов</NavLink>
            <NavLink to="/assistant-feedback" className={({ isActive }) => isActive ? `${cls.link} ${cls.active}` : cls.link}>Отзывы и исправления</NavLink></>}
        <a className={cls.link} href="/assistant">Вернуться к помощнику</a>
    </aside>;
    return (
    <aside className={cls.sidebar}>
        <div className={cls.brand}>LKFR Admin</div>

        <div className={cls.groupTitle}>Контент</div>
        <NavLink to="/news" className={({ isActive }) => (isActive ? `${cls.link} ${cls.active}` : cls.link)}>
            📰 Новости
        </NavLink>
        <div className={cls.groupTitle}>Контент</div>
        <NavLink to="/admin/promos" className={({ isActive }) => (isActive ? `${cls.link} ${cls.active}` : cls.link)}>
            📰 Промо
        </NavLink>

        <div className={cls.separator} />
        <div className={cls.groupTitle}>Сервис</div>
        {canReview && <NavLink to="/assistant-feedback" className={({ isActive }) => (isActive ? `${cls.link} ${cls.active}` : cls.link)}>Обратная связь ИИ</NavLink>}
        {canReview && <NavLink to="/assistant-history" className={({ isActive }) => (isActive ? `${cls.link} ${cls.active}` : cls.link)}>История ответов</NavLink>}
        <NavLink to="/" className={({ isActive }) => (isActive ? `${cls.link} ${cls.active}` : cls.link)}>
            📊 Дашборд
        </NavLink>

        <div className={cls.footer}>© LKFR, 2025</div>
    </aside>
);
};

export default Sidebar;
